﻿import { RESTError } from "../RESTError";

var BASE_URL = '/api/AutoNotifications';

export enum DownloadPermissionType {
    None,
    Regional,
    All
}

interface EmailAddressesUpdatesList {
    RegionId: string;
    RegionLabel: string;
    EmailsAdded: string[];
    EmailsRemoved: string[];
    DbValueCurrent: string[];
    DbValueNew: string[];
}

export interface EmailAddressesUpdatesResponse {
    Regions: EmailAddressesUpdatesList[];
    CountAdded: number;
    CountRemoved: number;
}

export interface EmailAddressesChangesRequestDataRegion {
    RegionId: string;
    EmailAddresses: string[];
}

export interface EmailAddressesChangesRequestData {
    Regions: EmailAddressesChangesRequestDataRegion[];
}

export interface MultiRegionsEmailsListResponseItem {
    RegionId: string;
    EmailRecipientsList: string[];
}

export interface MultiRegionsEmailsListResponse {
    Data: {
        [RegionId: string]: MultiRegionsEmailsListResponseItem
    }
}

export function getEmailAddresses(regionId: string, callback: (err: any, data: string[]) => any): void {
    $.ajax(BASE_URL + '/?regionId=' + encodeURIComponent(regionId), {
        cache: false,
        dataType: 'json',
        type: 'GET',
        timeout: 30000,
        success: (data: string[], text: string, jqXHR: JQueryXHR) => {
            callback(null, data);
        },
        error: (jqXHR: JQueryXHR, textStatus: string, errorThrown: string) => {
            callback(errorThrown, null);
        }
    });
}

export function getEmailAddressesMultiRegions(regions: string[], callback: (err: RESTError, data: MultiRegionsEmailsListResponse) => any): void {
    $.ajax(BASE_URL + '/MultiRegions/?regions=' + encodeURIComponent(regions.join(',')), {
        cache: false,
        dataType: 'json',
        type: 'GET',
        timeout: 30000,
        success: (data: MultiRegionsEmailsListResponse, text: string, jqXHR: JQueryXHR) => {
            callback(null, data);
        },
        error: (jqXHR: JQueryXHR, textStatus: string, errorThrown: string) => {
            callback(new RESTError(jqXHR), null);
        }
    });
}

export function emailAddressesChangesRequest(data: EmailAddressesChangesRequestData, callback: (err: RESTError, data: EmailAddressesUpdatesResponse) => any): void {
    $.ajax(BASE_URL + '/RequestChanges', {
        cache: false,
        type: 'POST',
        contentType: "application/json",
        data: JSON.stringify(data),
        timeout: 30000,
        success: (data: EmailAddressesUpdatesResponse, text: string, jqXHR: JQueryXHR) => {
            callback(null, data);
        },
        error: (jqXHR: JQueryXHR, textStatus: string, errorThrown: string) => {
            callback(new RESTError(jqXHR), null);
        }
    });
}

export function emailAddressesChangesConfirm(data: EmailAddressesUpdatesResponse, callback: (err: RESTError, data: EmailAddressesUpdatesResponse) => any): void {
    $.ajax(BASE_URL + '/ConfirmChanges', {
        cache: false,
        type: 'POST',
        contentType: "application/json",
        data: JSON.stringify(data),
        timeout: 30000,
        success: (data: EmailAddressesUpdatesResponse, text: string, jqXHR: JQueryXHR) => {
            callback(null, data);
        },
        error: (jqXHR: JQueryXHR, textStatus: string, errorThrown: string) => {
            callback(new RESTError(jqXHR), null);
        }
    });
}